import { HTMLInputAutoCompleteAttribute } from 'react';
import clsx from 'clsx';

import styles from './TextInput.module.scss';

interface TextInputProps {
  className?: string;
  tag?: 'input' | 'textarea';
  type?: 'text' | 'tel' | 'email';
  placeholder?: string;
  autoComplete?: HTMLInputAutoCompleteAttribute;
  value?: string;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const TextInput = ({
  className,
  tag = 'input',
  type,
  placeholder = '',
  autoComplete,
  value,
  error,
  onChange,
}: TextInputProps) => {
  return (
    <div className={clsx(styles.textInput, className)}>
      {tag === 'input' ? (
        <input
          className={styles.textInput__input}
          type={type}
          placeholder={placeholder}
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
        />
      ) : (
        <textarea
          className={styles.textInput__textarea}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      )}
      {Boolean(error) && <div className={styles.textInput__error}>{error}</div>}
    </div>
  );
};
